/**
 * @description Component-TradeDrawerMobile
 */
import Drawer from '@/components/Drawer';
import './index.less';

import TradeAreaOverlay from '@/components/TradeAreaOverlay';
import { useTradeStore } from '@/features/trade/store';
import TradeCard from '@/pages/trade/TradeCard';
import { FC } from 'react';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
  onClose?: () => void;
}

const TradeDrawerMobile: FC<IPropTypes> = function ({ onClose }) {
  const { isOpenMobileTradeDrawer, setIsOpenMobileTradeDrawer } = useTradeStore();
  return (
    <Drawer
      open={isOpenMobileTradeDrawer}
      onClose={() => {
        setIsOpenMobileTradeDrawer(false);
        onClose?.();
      }}
      placement="bottom"
      height="calc(100vh - 56px)"
      className="trade-drawer-mobile"
      title={null}
      footer={null}>
      <div className="trade-drawer-mobile-body">
        <TradeAreaOverlay />
        <TradeCard />
      </div>
    </Drawer>
  );
};

export default TradeDrawerMobile;
